import JourneyModes from "./JourneyModes.vue";
export default JourneyModes;
